import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children, requiredUserType = null }) {
  const { user, loading, session } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-steel"></div>
          <p className="mt-4 text-charcoal">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session || !user) {
    // Redirect to appropriate login page based on attempted route
    const loginPath = location.pathname.includes('worker') ? '/worker-login' : '/restaurant-login';
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Check if user type matches required type
  if (requiredUserType && user.user_type !== requiredUserType) {
    // Redirect to correct dashboard for their user type
    const correctPath = user.user_type === 'worker' ? '/dashboard/worker' : '/dashboard/restaurant';
    return <Navigate to={correctPath} replace />;
  }

  return children;
}

export default ProtectedRoute;